<template>
    <el-form class="inline-form"
            ref="refForm"
            :id="refForm"
            :disabled="isForceDisplay"
            :model="formData"
            :label-width="0"
            :action="action"
            method="post"
            :label-position="formItemPosition"
            enctype="multipart/form-data"
            status-icon
            size="large">
            <component class="field_item" 
                    v-for="(field, index) in layout"
                    :style="'width:' + (widthMap[field.Name] || 0) + 'px'"
                    :key="field.Name"
                    :is="field.FieldDefinition.Name"
                    :definition="field"
                    :data="formData"
                    :contentType="requestContentType"
                    :formDefinition = "formDefinition"
                    :orginalDisplay = "orginalDisplay">
            </component>
    </el-form>
    
</template>

<style>
    .inline-form label{
        display: none;
    }
    .inline-form .el-form-item__label{
        display: none;
    }
    .inline-form .field_item{
        display: inline-flex;
    }
</style>


<script>
    import baseFormItem from "./BaseFormItem"

    export default {
        name:"tableInlineForm",
        mixins:[baseFormItem],
        data:function(){
            return {
                widthMap:{
                },

                initDataState:false,
            }
        },

        emits:["setParentValue"],

        created:function(){
            this.widthMap = this.propDatas.WidthMap;
            this.watchForm = this.$watch("formData",{
                handler(newVal, oldVal) {
                    this.$emit("setParentValue", {
                        "formData": newVal,
                        "guid": newVal.QweGuid
                    });
                },
                deep: true
            })
        },

        watchForm:{},

        methods:{
            initData:function(Data){
                this.watchForm();
                this.$nextTick(()=>{
                    this.contentDefinition.forEach(x=> {
                        this.formData[x.Name] = Data[x.Name];
                    });
                    this.formData["QweGuid"] = Data["QweGuid"];
                    this.watchForm = this.$watch("formData",{
                        handler(newVal, oldVal) {
                            this.$emit("setParentValue", {
                                "formData": newVal,
                                "guid": newVal.QweGuid
                            });
                        },
                        deep: true
                    })
                })
            }
        }
    }
</script>